import React from "react";
// @ts-ignore
import Battery0 from './Batterij_0.svg';
// @ts-ignore
import Battery25 from './Batterij_25.svg';
// @ts-ignore
import Battery50 from './Batterij_50.svg';
// @ts-ignore
import Battery75 from './Batterij_75.svg';
// @ts-ignore
import Battery100 from './Batterij_100.svg';
import "external-svg-loader";
export var BatteryBars0 = function () {
    return React.createElement("svg", { "data-src": Battery0 });
};
export var BatteryBars25 = function () {
    return React.createElement("svg", { "data-src": Battery25 });
};
export var BatteryBars50 = function () {
    return React.createElement("svg", { "data-src": Battery50 });
};
export var BatteryBars75 = function () {
    return React.createElement("svg", { "data-src": Battery75 });
};
export var BatteryBars100 = function () {
    return React.createElement("svg", { "data-src": Battery100 });
};
export default BatteryBars0;
